declare let cli: BpmnJsCli;

export class BpmnJsCliWrapper {

    public static setLabel(element: BpmnJsElement | string | undefined, label: string | undefined) {
        cli.setLabel(element, label);
    }

    public static createElement(elementType: string, position: { x: number, y: number }, parent: BpmnJsElement) {
        cli.create(elementType, position, parent);
    }

    public static toggleDefaultBranch(elementId: string) {
        cli.toggleDefaultBranch(elementId);
    }

    public static element(element: BpmnJsElement | string | undefined): BpmnJsElement {
        return cli.element(element);
    }

    public static elements(): string[] {
        return cli.elements();
    }

    public static toggleStandardLoopCharacteristicsIcon(element: BpmnJsElement | string) {
        cli.toggleStandardLoopCharacteristicsIcon(element);
    }

    public static async exportXML(): Promise<BpmnExportResult> {
        return await cli.exportXML();
    }

    public static async  exportSVG(): Promise<BpmnExportResult> {
        return await cli.exportSVG();
    }

    public static importXml(xml: string) {
        cli.importXML(xml);
    }

    public static openMinimap() {
        cli.openMinimap();
    }

    public static fireElementChanged(element: BpmnJsElement | string) {
        cli.fireElementChanged(element);
    }
}
